export const container = `
  group/item-button group/color-icon flex justify-between items-center
  text-sm font-normal text-gray-800
  w-full h-11 py-2

  data-[is-collapsed=true]:pointer-events-none
`;
export const text = `grow text-left text-nowrap px-2 group-data-[is-collapsed=true]/item-button:invisible group-hover/item-button:text-base-black -mt-0.5`;
export const arrow = `group-data-[is-collapsed=true]/item-button:invisible group-hover/item-button:scale-125`;
